import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * OAuth Callback handler for Outlook calendar integration
 * This component is displayed after user authorizes with Microsoft
 */
const OutlookCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    const errorParam = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (errorParam) {
      setError(errorDescription || errorParam);
      setTimeout(() => {
        navigate('/settings');
      }, 3000);
      return;
    }

    if (code) {
      // Send message to parent window (Settings page)
      if (window.opener) {
        window.opener.postMessage({
          type: 'outlook-auth-success',
          code: code
        }, window.location.origin);
        
        // Close this window after sending the message
        setTimeout(() => {
          window.close();
        }, 1000);
      } else {
        // If not opened as popup, redirect to settings
        setError('Please complete the OAuth flow from the Settings page');
        setTimeout(() => {
          navigate('/settings');
        }, 3000);
      }
    } else {
      setError('No authorization code received');
      setTimeout(() => {
        if (window.opener) {
          window.close();
        } else {
          navigate('/settings');
        }
      }, 3000);
    }
  }, [searchParams, navigate]);

  return (
    <Box 
      display="flex" 
      flexDirection="column"
      justifyContent="center" 
      alignItems="center" 
      minHeight="100vh"
      gap={3}
    >
      {error ? (
        <>
          <Alert severity="error">
            {error}
          </Alert>
          <Typography variant="body2" color="text.secondary">
            Redirecting...
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress size={60} />
          <Typography variant="h6">
            Completing authentication...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This window will close automatically
          </Typography>
        </>
      )}
    </Box>
  );
};

export default OutlookCallback;
